import { PriceA11y } from "./priceA11yInterface";
import { Hotel } from "src/typings/microserviceModels/hotels-flex-module";
import { DATE_FORMAT } from "../constants";

export class HotelPriceLockupWithDates implements PriceA11y {
  formattedPrice: string;
  checkInDateFormatted: string;
  checkOutDateFormatted: string;
  formatText: (key: string, ...args: any[]) => string;

  public constructor(
    hotel: Hotel,
    formatText: (key: string, ...args: any[]) => string,
    formatDateString: (key: string, ...args: any[]) => string
  ) {
    this.formattedPrice = hotel.formattedPrice;
    this.checkInDateFormatted = formatDateString(hotel.isoCheckIn, { skeleton: DATE_FORMAT });
    this.checkOutDateFormatted = formatDateString(hotel.isoCheckOut, { skeleton: DATE_FORMAT });
    this.formatText = formatText;
  }

  public getA11yText = () =>
    this.formatText(
      "hotels.priceWithDates.a11y",
      this.formattedPrice,
      this.checkInDateFormatted,
      this.checkOutDateFormatted
    );
}
